import { Box } from '@factorialco/deprecated-design-system'
import { FinancialDocumentEventFragment } from 'generated/resources/graphql'

import { SaleInvoiceActivityRow } from './_SaleInvoiceActivityRow'

interface SaleInvoiceActivityProps {
  events?: FinancialDocumentEventFragment[] | null
}

const SaleInvoiceActivity = ({ events }: SaleInvoiceActivityProps) => {
  if (!events || events.length === 0) return <></>

  const lastIndex = events.length - 1
  return (
    <Box padding="s24" width="full">
      {events.map((event, index) => (
        <SaleInvoiceActivityRow key={index} event={event} showLine={index !== lastIndex} />
      ))}
    </Box>
  )
}

export default SaleInvoiceActivity
